import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage, SignupPage, CompleteProfilePage, PendingApprovalPage } from '../../modules/auth';
import RecordsPage from '../../modules/Records';
import { PublicProjectsPage, AboutPage, ContactPage } from '../../modules/PublicDashboard';
import RoleGuard from '../guards/RoleGuard';
import HomeRoute from './HomeRoute';

function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeRoute />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/records" element={<RecordsPage />} />
        <Route path="/projects" element={<PublicProjectsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />

        <Route element={<RoleGuard />}>
          <Route path="/complete-profile" element={<CompleteProfilePage />} />
          <Route path="/pending-approval" element={<PendingApprovalPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;
